<template>
  <fragment>
    <div>
      <div class="wraper">
        <div class="container-fluid mycontainer-fluid">
          <slot name="header"></slot>
          <div class="row myrow">
            <div class="col-xs-12 mycol header-title">
              <div class="col-xs-12 mycol">
                <div class="h-t-name pull-left">Группы компаний</div>
                <div class="pull-right">
                  <router-link
                    :to="{
                      name: 'GOList'
                    }"
                    class="btn btn-success"
                    style="margin-right: 12px"
                  >
                    Администрирование списка ГК
                  </router-link>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="container-fluid mycontainer-fluid content content_table">
          <div class="wrapper-header">
            <form>
              <div class="row myrow project-filter filter-wrapper-stl">
                <div
                  class="col-xs-12 col-md-3 col-lg-2 mycol-l filter-stl-holder"
                >
                  <input
                    id="filter_number"
                    type="text"
                    class="filter-input-stl"
                    v-model="filter.org_name"
                    placeholder="Организация"
                  />
                </div>
                <div
                  class="col-xs-12 col-md-3 col-lg-2 mycol-l filter-stl-holder"
                >
                  <input
                    type="text"
                    class="filter-input-stl"
                    v-model="filter.ogrn"
                    placeholder="ОГРН"
                  />
                </div>
                <div
                  class="col-xs-12 col-md-3 col-lg-2 mycol-l filter-stl-holder"
                >
                  <input
                    type="text"
                    class="filter-input-stl"
                    v-model="filter.inn"
                    placeholder="ИНН"
                  />
                </div>
                <div
                  class="col-xs-12 col-md-3 col-lg-2 mycol-l filter-stl-holder"
                >
                  <Multiselect
                    label="UF_NAME"
                    class="i-main-style i-wid-100 stl-bs_bb multiselect-filter-project-register select-new-filter-style filter-select-stl"
                    :loading="!listRendered"
                    :limit="1"
                    :limitText="filterItemText"
                    track-by="ID"
                    v-model="filter.org"
                    :options="orgs"
                    :multiple="true"
                    placeholder="Группа компаний"
                  />
                </div>
                <div
                  class="col-xs-12 col-md-3 col-lg-2 mycol-l filter-stl-holder"
                >
                  <select class="filter-select-stl" v-model="filter.status">
                    <option value="">Статус</option>
                    <option :value="-1">Нет информации</option>
                    <option
                      v-for="item in directory.sp_status_group_orgs"
                      :value="item.ID"
                      :key="item.ID"
                      v-text="item.NAME"
                    ></option>
                  </select>
                </div>
                <div class="stl-df-ac" style="width: 394px;">
                  <div
                    class="col-xs-12 col-md-3 col-lg-2 mycol-l filter-stl-holder"
                  >
                    <button
                      class="project-filter__butt-btn butt-new-style butt-new-style-reset stl-w-full"
                      @click="clearFilter"
                      type="button"
                    >
                      Сброс
                    </button>
                  </div>
                  <div
                    class="col-xs-12 col-md-3 col-lg-2 mycol-l filter-stl-holder"
                  >
                    <button
                      class="project-filter__butt-btn butt-new-style stl-w-full"
                      type="button"
                      @click="fetchList"
                    >
                      Применить
                    </button>
                  </div>
                </div>
              </div>
            </form>
          </div>
          <div class="table-responsive container-stl" v-if="!isExpsLoading">
            <table class="table  table-hover table-striped">
              <thead>
                <tr>
                  <th class="text-nowrap">
                    №<a
                      v-on:click="setOrder('UF_NUMBER')"
                      class="sort"
                      v-bind:class="{
                        desc: sortColumn === 'UF_NUMBER' && sortOrder === 'DESC'
                      }"
                    ></a>
                  </th>
                  <th class="text-nowrap">
                    Организация<a
                      v-on:click="setOrder('UF_COMPANY_ID')"
                      class="sort"
                      v-bind:class="{
                        desc:
                          sortColumn === 'UF_COMPANY_ID' && sortOrder === 'DESC'
                      }"
                    ></a>
                  </th>
                  <th class="text-nowrap">
                    ОГРН<a
                      v-on:click="setOrder('COMPANY_OGRN')"
                      class="sort"
                      v-bind:class="{
                        desc:
                          sortColumn === 'COMPANY_OGRN' && sortOrder === 'DESC'
                      }"
                    ></a>
                  </th>
                  <th class="text-nowrap">
                    ИНН<a
                      v-on:click="setOrder('COMPANY_INN')"
                      class="sort"
                      v-bind:class="{
                        desc:
                          sortColumn === 'COMPANY_INN' && sortOrder === 'DESC'
                      }"
                    ></a>
                  </th>
                  <th class="text-nowrap">
                    Группа компаний<a
                      v-on:click="setOrder('GROUP_COMPANY')"
                      class="sort"
                      v-bind:class="{
                        desc:
                          sortColumn === 'GROUP_COMPANY' && sortOrder === 'DESC'
                      }"
                    ></a>
                  </th>
                  <th class="text-nowrap">
                    Статус<a
                      v-on:click="setOrder('UF_STATUS_ID')"
                      class="sort"
                      v-bind:class="{
                        desc:
                          sortColumn === 'UF_STATUS_ID' && sortOrder === 'DESC'
                      }"
                    ></a>
                  </th>
                  <td></td>
                </tr>
              </thead>
              <tbody v-if="groupOrgs && groupOrgs.counts">
                <tr
                  class="new"
                  unselectable="on"
                  style="cursor: default"
                  v-for="project in groupOrgs.items"
                  v-bind:key="project.ID"
                >
                  <td>{{ project.UF_NUMBER }}</td>
                  <td>{{ project.COMPANY.NAME }}</td>
                  <td>{{ project.COMPANY_OGRN }}</td>
                  <td>{{ project.COMPANY_INN }}</td>
                  <td>{{ project.GROUP_COMPANY.NAME }}</td>
                  <td>{{ project.STATUS.NAME }}</td>
                  <td>
                    <a
                      v-if="isEdit"
                      class="link-edit-row"
                      @click="getItem(project)"
                    ></a>
                  </td>
                </tr>
              </tbody>
              <tbody v-else>
                <tr>
                  <td colspan="7">Записи не найдены</td>
                </tr>
              </tbody>
              <tfoot>
                <tr>
                  <td colspan="10">
                    <div class="paging">
                      <div class="container-fluid">
                        <div class="row">
                          <div class="col-xs-6 mycol">
                            <Pagination
                              :pages="pages"
                              :currentPage.sync="currentPage"
                            ></Pagination>
                          </div>
                          <div class="col-xs-6 mycol">
                            <div class="pull-right page-total">
                              <span style="padding-right: 15px"
                                >Всего: {{ groupOrgs.counts }}</span
                              >
                              <span>Выводить по </span>
                              <span>
                                <select
                                  class="page-select"
                                  v-model="itemsPerPage"
                                >
                                  <option value="20">20</option>
                                  <option value="40">40</option>
                                  <option value="100">100</option>
                                  <option value="500">500</option>
                                </select>
                              </span>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </td>
                </tr>
              </tfoot>
            </table>
          </div>
          <div v-else>
            <h3>Загрузка...</h3>
          </div>
          <div
            class="modal fade in"
            v-bind:class="{ show: showEditNewProject }"
            tabindex="-1"
            role="dialog"
          >
            <form v-on:submit.prevent="onEditProject">
              <div class="modal-dialog" role="document">
                <div class="modal-content">
                  <div class="modal-header">
                    <button
                      type="button"
                      class="close"
                      v-on:click="showEditNewProject = false"
                      aria-label="Close"
                    >
                      <span aria-hidden="true">&times;</span>
                    </button>
                    <h4 class="modal-title">Указание группы компаний</h4>
                  </div>
                  <div class="modal-body">
                    <div
                      class="alert alert-danger"
                      v-show="addError !== ''"
                      role="alert"
                    >
                      {{ addError }}
                    </div>
                    <div class="form-group">
                      <label>Компания состоит в ГК</label>
                      <select
                        class="form-control"
                        v-model="newProject.IS_ADD_IN_GROUP"
                      >
                        <option :value="0">Нет</option>
                        <option :value="1">Да</option>
                      </select>
                    </div>
                    <div class="form-group">
                      <label>Группа компаний</label>
                      <select
                        class="form-control"
                        v-model="newProject.UF_GRP_CMP_ID"
                        :disabled="newProject.IS_ADD_IN_GROUP == 0"
                      >
                        <option
                          v-for="item in orgs"
                          v-bind:value="item.ID"
                          v-bind:key="item.ID"
                          v-text="item.UF_NAME"
                        ></option>
                      </select>
                    </div>
                    <div class="form-group">
                      <label>Комментарий</label>
                      <textarea
                        :disabled="newProject.IS_ADD_IN_GROUP == 0"
                        class="form-control"
                        v-model="newProject.UF_COMMENT"
                      >
                      </textarea>
                    </div>
                  </div>
                  <div class="modal-footer">
                    <button
                      type="button"
                      class="btn btn-default"
                      data-dismiss="modal"
                      v-on:click="showEditNewProject = false"
                    >
                      Отмена
                    </button>
                    <button type="submit" class="btn btn-primary">
                      Редактировать
                    </button>
                  </div>
                </div>
                <!-- /.modal-content -->
              </div>
              <!-- /.modal-dialog -->
            </form>
          </div>
          <!-- /.modal -->
        </div>
      </div>
      <!-- wraper -->
    </div>
    <div class="footer footer-fix">
      <div class="container-fluid mycontainer-fluid">
        <div class="myfooter">
          <div class="myfooter-frp pull-left"></div>
          <div class="pull-right"></div>
        </div>
      </div>
    </div>
  </fragment>
</template>

<script>
import Pagination from "@/components/Pagination";
import { mapGetters } from "vuex";
import {
  SET_MAIN_MENU,
  FETCH_DIRECTORIES,
  FETCH_GROUP_ORGS,
  SET_IS_VIEW_ALL_EXPERTISE
} from "@/store/actions.type";
import { GroupOrgs, ProjectsService } from "@/common/api.service";
import { AUTH_URL } from "@/common/config";
import Datepicker from "vuejs-datepicker";
import { ru } from "vuejs-datepicker/dist/locale";
import Multiselect from "vue-multiselect";

export default {
  title: "Группы компаний",
  components: {
    Pagination,
    Datepicker,
    Multiselect
  },
  data() {
    return {
      siteUrl: "",
      extendFilter: false,
      filter: {
        inn: "",
        ogrn: "",
        number: "",
        org: "",
        status: ""
      },
      itemsPerPage: 20,
      currentPage: 1,
      sortOrder: "",
      sortColumn: "",
      showCreateNewProject: false,
      showEditNewProject: false,
      listRendered: false,
      sp: {
        statuses: []
      },
      ru: ru,
      newProject: {
        UF_NUMBER: "",
        UF_DATE_SOVET: ""
      },
      addError: "",
      orgs: [],
      isEdit: false
    };
  },
  mounted() {
    this.siteUrl = AUTH_URL.replace(new RegExp("[\\/]+$"), "");

    this.$store.dispatch(SET_MAIN_MENU, []);
    ProjectsService.getManagerRoleDefaultSetting().then(({ data }) => {
      this.$store.dispatch(
        SET_IS_VIEW_ALL_EXPERTISE,
        data.IS_VIEW_ALL_EXPERTISE
      );
      this.isEdit = data.IS_REDACT_GROUP_ORG;
      let navMainMenu = [];
      if (data.START_PAGE === "REESTR_PROJECTS") {
        if (data.IS_REESTR_PROJECTS) {
          navMainMenu.push({
            name: "Реестр проектов",
            route: "Projects"
          });
        }
        if (data.IS_REESTR_EXPERTISE) {
          navMainMenu.push({
            name: "Реестр экспертиз",
            route: "Expertise"
          });
        }
        /*if (data.IS_VIEW_MONITOR_LIZING) {
          navMainMenu.push({
            name: "Мониторинг Лизинговых<br/> компаний",
            class: "two_line",
            route: "MonitoringLizingOrgs"
          });
        }
        if (data.IS_VIEW_PLAN_ES) {
          navMainMenu.push({
            name: "Заседания",
            route: "Experts"
          });
        }*/
        if (data.IS_VIEW_GROUP_ORG) {
          navMainMenu.push({
            name: "Группы компаний",
            route: "GroupOrgs"
          });
        }
        /*navMainMenu.push({
          name: "Запросы",
          route: "Requests"
        });*/
      } else {
        if (data.IS_REESTR_EXPERTISE) {
          navMainMenu.push({
            name: "Реестр экспертиз",
            route: "Expertise"
          });
        }
        if (data.IS_REESTR_PROJECTS) {
          navMainMenu.push({
            name: "Реестр проектов",
            route: "Projects"
          });
        }
        /*if (data.IS_VIEW_PLAN_ES) {
          navMainMenu.push({
            name: "Заседания",
            route: "Experts"
          });
        }
        if (data.IS_VIEW_MONITOR_LIZING) {
          navMainMenu.push({
            name: "Мониторинг Лизинговых<br/> компаний",
            class: "two_line",
            route: "MonitoringLizingOrgs"
          });
        }*/
        if (data.IS_VIEW_GROUP_ORG) {
          navMainMenu.push({
            name: "Группы компаний",
            route: "GroupOrgs"
          });
        }
        /*navMainMenu.push({
          name: "Запросы",
          route: "Requests"
        });*/
      }
      this.$store.dispatch(SET_MAIN_MENU, navMainMenu);
    });

    this.$store.dispatch(FETCH_DIRECTORIES, ["sp_status_group_orgs"]);

    GroupOrgs.getListGroupOrgs({ allList: 1 }).then(({ data }) => {
      this.orgs = data.items;
      this.listRendered = true;
    }, this);

    this.fetchList();
  },
  computed: {
    ...mapGetters([
      "groupOrgs",
      "userProjectProgrammes",
      "addProjectError",
      "isExpsLoading",
      "currentUser",
      "directory",
      "DProgramFinSupport"
    ]),
    listConfig() {
      const q = {
        page: this.currentPage,
        limit: this.itemsPerPage,
        filter: {}
      };
      if (this.sortColumn !== "") {
        let sort = {
          column: "",
          order: ""
        };
        sort.column = this.sortColumn;
        sort.order = this.sortOrder;
        q.sort = sort;
      }
      if (this.filter.status !== "") {
        q.filter.UF_STATUS_GRP_ID = this.filter.status;
      }
      if (this.filter.org.length) {
        q.filter.GROUP_ID = [];
        this.filter.org.forEach(function(it) {
          q.filter.GROUP_ID.push(it.ID);
        }, this);
      }
      if (this.filter.org_name !== "") {
        q.filter.COMPANY_NAME = this.filter.org_name;
      }
      if (this.filter.inn !== "") {
        q.filter.COMPANY_INN = this.filter.inn;
      }
      if (this.filter.ogrn !== "") {
        q.filter.COMPANY_OGRN = this.filter.ogrn;
      }

      return q;
    },
    pages() {
      if (
        this.isExpsLoading ||
        !this.groupOrgs.counts ||
        this.groupOrgs.counts <= this.itemsPerPage
      ) {
        return [];
      }
      return [
        ...Array(Math.ceil(this.groupOrgs.counts / this.itemsPerPage)).keys()
      ].map(e => e + 1);
    }
  },
  watch: {
    currentPage(newValue) {
      this.listConfig.page = newValue;
      this.fetchList();
    },
    itemsPerPage(newValue) {
      this.listConfig.limit = newValue;
      this.fetchList();
    }
  },
  methods: {
    getPTypeId(id) {
      let t = this.directory.program_fin_support.filter(c => c.ID === id);
      if (t && t.length > 0) {
        return t[0].NAME;
      }
      return "";
    },
    setOrder(column) {
      if (this.sortColumn !== column) {
        this.sortOrder = "ASC";
      } else {
        if (this.sortOrder === "DESC") {
          this.sortOrder = "ASC";
        } else {
          this.sortOrder = "DESC";
        }
      }
      this.sortColumn = column;
      this.fetchList();
    },
    clearFilter() {
      this.filter = {
        org: []
      };
      this.fetchList();
    },
    fetchList() {
      this.$store.dispatch(FETCH_GROUP_ORGS, this.listConfig);
      this.$store.dispatch(FETCH_DIRECTORIES, ["regions"]);
    },
    getItem(item) {
      GroupOrgs.getRecordOrgGroup(item.COMPANY.UF_COMPANY_ID)
        .then(({ data }) => {
          this.newProject = data;
          this.newProject.ID = item.COMPANY.UF_COMPANY_ID;
          this.showEditNewProject = true;
        }, this)
        .catch(() => {
          this.addError = this.addProjectError;
        });
      return false;
    },
    onEditProject() {
      if (!this.newProject.IS_ADD_IN_GROUP) {
        this.newProject.UF_GRP_CMP_ID = 0;
        this.newProject.UF_COMMENT = "";
      }
      GroupOrgs.editRecordOrgGroup(this.newProject.ID, this.newProject)
        .then(() => {
          this.fetchList();
          this.showEditNewProject = false;
          this.newProject = {};
        }, this)
        .catch(() => {
          this.addError = this.addProjectError;
        });
      return false;
    },
    filterItemText(count) {
      return `и еще ${count}`;
    }
  }
};
</script>
